import React from 'react'
import PropTypes from 'prop-types'

const AddressInfo = props =>
  props.address ? (
    <div className='row product-brand pt-2  px-2'>
      <div className='col-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center'>
        <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
          <strong>{props.receiver}</strong>
        </p>
        <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
          <strong>
            {props.address.addressText}, {props.address.number}
            {' - '}
            {props.address.complement}
          </strong>
        </p>
        <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
          <strong>
            {props.address.district} - {props.address.city} -{' '}
            {props.address.state} - {props.address.zipCode}
          </strong>
        </p>
      </div>
    </div>
  ) : (
    ''
  )

AddressInfo.propTypes = {
  address: PropTypes.object,
  receiver: PropTypes.string
}

export default AddressInfo



// WEBPACK FOOTER //
// ./src/features/AboutOrder/AddressInfo.js